<template>
  <v-row>
    <v-col v-for="[ key, type, serialized ] in templates" :key="key" class="relative" cols="4">
      <v-card tile hover @click="select(serialized)">
        <card-preview :card="{ background, pages: [ JSON.parse(serialized) ] }" mode="edit" />
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import CardPreview from '@/components/CardPreview.vue';
import uuid4 from '@/utils/uuid';
import { mdiClose } from '@mdi/js';


const BASE_URL = 'https://cdn.ellacard.com/';

const DEFAULT = [
  'r/5937ffef-906d-4887-b78f-4cb60efdf82c',
  'image/jpeg',
  '{\"blobs\": []}'
];


export default {
  name: 'page-layout-picker',

  components: {
    CardPreview
  },

  props: [ 'background' ],

  data() {
    return {
      templates: [ DEFAULT ],
      loadStatus: this.$track('load')
    };
  },

  created() {
    Object.assign(this, { mdiClose, BASE_URL });
    this.load();
  },

  methods: {
    async load() {
      let templates;
      const t = new Date();
      if (window._pageLayoutCache && (t - window._pageLayoutCache.t < 15 * 60 * 1000)) {
        templates = _pageLayoutCache.templates;
      } else {
        templates = await this.$call('list-page-templates');
        window._pageLayoutCache = { templates, t };
      }
      this.templates = templates;
    },

    select(serialized) {
      const template = JSON.parse(serialized);
      for (const blob of template.blobs) {
        if (blob.type == 'TEXT' || blob.mask)
          blob.template = 'page';
        blob.id = uuid4();
      }
      this.$emit('select', template);
    }
  }
}
</script>
